'use es6';

import { Component } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import AfterBeginPortal from 'ContentEditorUI/components/portals/BeforeBeginPortal';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ExitPreviewAndLayoutModeButton extends Component {
  render() {
    const {
      type,
      onClick
    } = this.props;
    const classes = type === 'preview' ? 'exitPreviewModeBtn contentEditor-button-link' : 'exitLayoutModeBtn contentEditor-button-link';
    const dataAction = type === 'preview' ? 'exitPreviewMode' : 'exitLayoutMode';
    const message = type === 'preview' ? 'quickView.exitPreviewBtn' : 'layoutMode.exitLayoutMode';
    return /*#__PURE__*/_jsx(AfterBeginPortal, {
      id: 'exit-preview-and-layout-mode-button-container',
      targetElement: document.getElementsByClassName('contentEditor-exitButton')[0],
      children: /*#__PURE__*/_jsxs(UIButton, {
        use: "tertiary",
        "data-action": dataAction,
        className: classes,
        onClick: onClick,
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "remove"
        }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: message
        })]
      })
    }, 'exit-preview-and-layout-mode-button-container');
  }
}
ExitPreviewAndLayoutModeButton.propTypes = {
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func
};
export default ExitPreviewAndLayoutModeButton;